/** @type {import('tailwindcss').Config} */
/**
 * Tailwind config — Artificers AI design system
 * --------------------------------------------------
 * theme.extend is sourced entirely from src/styles/tokens.js.
 * Edit tokens there; this file is just the Tailwind wiring.
 * See /docs/design-system.md for the full token catalogue.
 *
 * NOTE: StyleguidePage.jsx imports this file directly to read tokens
 * at runtime, so it must remain pure ESM with no Node-only APIs.
 */
import { theme } from './src/styles/tokens.js';

export default {
  content: ['./index.html', './src/**/*.{js,jsx}'],
  theme: {
    extend: theme,
  },
  plugins: [],
};
